import type {StateCreator} from 'zustand'
import type {Codeowners} from '../../page-data/payloads/codeowners'

export type CodeownersSlice = {
  codeowners?: Codeowners
  shouldLoadCodeowners: boolean
  codeownersActions: {
    setCodeowners: (codeowners?: Codeowners) => void
  }
}

export type CodeownersSliceOpts = {
  shouldLoadCodeowners: boolean
}

export const createCodeownersSlice =
  ({shouldLoadCodeowners}: CodeownersSliceOpts): StateCreator<CodeownersSlice, [['zustand/devtools', never]]> =>
  (set, _get) => ({
    codeowners: undefined,
    shouldLoadCodeowners,
    codeownersActions: {
      setCodeowners: (codeowners?: Codeowners) => {
        set({codeowners}, undefined, 'updateCodeowners')
      },
    },
  })
